import SectionLabel from "@/components/base/SectionLabel";
import { pricingData } from "@/mocks/pricingData";

export default function ProductionDevSection() {
  return (
    <section id="production-dev" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="reveal grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-start">
          <div>
            <SectionLabel label={pricingData.productionDev.label} className="mb-3" />
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3 md:mb-4">
              {pricingData.productionDev.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-5">
              {pricingData.productionDev.description}
            </p>
            <div className="inline-flex px-4 py-2.5 rounded-full bg-secondary-100 border border-secondary-200/60 mb-5">
              <span className="text-sm md:text-base font-bold text-secondary-700">
                {pricingData.productionDev.pricing}
              </span>
            </div>
            <div className="bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/70">
              <div className="flex items-start gap-2.5">
                <i className="ri-information-line text-primary-500 mt-0.5" />
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {pricingData.productionDev.note}
                </p>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-7">
            <ul className="space-y-3">
              {pricingData.productionDev.items.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <div className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-secondary-600 text-sm`} />
                  </div>
                  <span className="text-sm md:text-base text-foreground-700">{item.label}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}